import {
  StepItem,
  StepsProps
} from "../../../../../../shared/components/Steps";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces/identityVerificationRequest";

export const getIdentityVerificationPayeeProgressSteps = (
  status: IdentityVerificationRequestStatus
): StepItem[] => {
  const allStepsCombinations: Record<
    IdentityVerificationRequestStatus,
    StepsProps["steps"]
  > = {
    [IdentityVerificationRequestStatus.Complete]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Complete"
      }
    ],
    [IdentityVerificationRequestStatus.Pending]: [
      {
        title: "Start",
        status: "Active"
      },
      {
        title: "Processed",
        status: "Pending"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [IdentityVerificationRequestStatus.Failed]: [
      {
        title: "Start",
        status: "Complete"
      },
      {
        title: "Processed",
        status: "Failed"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ]
  };

  return allStepsCombinations[status];
};
